import React, {useEffect, useState} from 'react';
import Input from "../Common/Input";
import Button from "../Common/Button";
import {ORDER_STATUS, VARIANT} from "../../constants";
import ImageBasic from "../Common/Image/ImageBasic";
import IMG from "../../constants/image";
import {cleanNumber, formatNumberWithDots, scrollToTop, validatePhone} from "../../utils";
import popupStore from "../../store/popupStore";
import {isMobile} from "react-device-detect";
import {setConfirmOrder} from "../../network/orderApi";
import {clsx} from "clsx";
import {text} from "../../constants/text";
import CourierInfoSeller from "./seller/CourierInfoSeller";
import {useSyncOrderAfterStatusChange} from "../../hooks/useSyncOrderAfterStatusChange";

const ShippingConfirmationForm = ({title, orderId}) => {
  const syncOrderAfterStatusChange = useSyncOrderAfterStatusChange();
  const {setPopup, setPopupMobile} = popupStore()
  const [formData, setFormData] = useState({
    orderId: "",
    isApprove: true,
    shippingInfo: {
      shippingMethod: "self",
      deliveryETA: "",
      shippingFee: "0",
      shippingData: {
        logisticsProvider: "",
        trackingNumber: ""
      }
    }
  });

  const [errors, setErrors] = useState({
    logisticsProvider: '',
    trackingNumber: '',
    shippingFee: '',
  });
  const validateForm = () => {
    const newErrors = {};
    let valid = true;

    if (!formData.name) {
      newErrors.name = text.storeNameRequired;
      valid = false;
    }

    if (!formData.phoneNumber) {
      newErrors.phoneNumber = text.phoneNumberRequired;
      valid = false;
    } else {
      if (!validatePhone(formData.phoneNumber)) {
        newErrors.phoneNumber = text.invalidPhoneNumber;
        valid = false;
      }
    }

    if (!formData.address) {
      newErrors.address = text.shippingAddressRequired;
      valid = false;
    }

    if (!valid) {
      scrollToTop();
    }
    setErrors(newErrors);
    return valid;
  };
  const handleChange = (e) => {
    let {name, value} = e.target;
    setErrors({...errors, [name]: ''});
    if (name === 'shippingFee') {
      value = cleanNumber(value)
    }
    setFormData(prev => ({
      ...prev,
      shippingInfo: {
        ...prev.shippingInfo,
        ...(name === 'shippingFee' && {shippingFee: value}),
        shippingData: {
          ...prev.shippingInfo.shippingData,
          ...(name === 'logisticsProvider' && {logisticsProvider: value}),
          ...(name === 'trackingNumber' && {trackingNumber: value})
        }
      }
    }));
  };

  const handleSubmit = async () => {
    setConfirmOrder(formData).then((res) => {
      if (res.success) {
        syncOrderAfterStatusChange(orderId, ORDER_STATUS.SHIPPING_PROCESSING).then(() => {
          if (isMobile) setPopupMobile({})
          else setPopup({})
        })
      }
    })
  };

  const handleClose = () => {
    if (isMobile) return setPopupMobile({});
    return setPopup({})
  }
  useEffect(() => {
    if (orderId)
      setFormData({
        orderId: orderId,
        isApprove: true,
        shippingInfo: {
          shippingMethod: "self",
          deliveryETA: "",
          shippingFee: "0",
          shippingData: {
            logisticsProvider: "",
            trackingNumber: ""
          }
        }
      })
  }, [orderId])
  const {logisticsProvider, trackingNumber} = formData.shippingInfo.shippingData;
  return (
    <form onSubmit={handleSubmit} className="animate-fadeIn space-y-4 w-full px-4 md:px-0 md:w-[600px]">
      <div className='flex text-sm font-bold space-x-2 items-center justify-center pt-4 md:pt-0'>
        <ImageBasic src={IMG.icon.document}/>
        <div>{title}</div>
      </div>
      <CourierInfoSeller/>
      <div className='p-4 space-y-4 bg-white rounded-[10px]'>
        <Input
          title={'Đơn vị vận chuyển/ Nhà xe'}
          helper={'(nếu có)'}
          placeholder={'Đơn vị vận chuyển'}
          setError={setErrors}
          name={'logisticsProvider'}
          error={errors.logisticsProvider}
          value={logisticsProvider}
          onChange={handleChange}
        />
        <Input
          title={'Mã vận đơn'}
          helper={'(nếu có)'}
          name={'trackingNumber'}
          placeholder={'Mã vận đơn của đơn vị vận chuyển cung cấp'}
          type="text"
          error={errors.trackingNumber}
          value={trackingNumber}
          setError={setErrors}
          onChange={handleChange}
        />
        <Input
          type='text'
          title={'Phí vận chuyển'}
          helper={'(nếu có)'}
          placeholder={'đ'}
          setError={setErrors}
          name={'shippingFee'}
          value={parseInt(formData.shippingInfo.shippingFee) > 0 ? `${formatNumberWithDots(formData.shippingInfo.shippingFee)}` : ''}
          error={errors.shippingFee}
          onChange={handleChange}
        />
      </div>
      <div className="md:flex md:space-x-4 px-4 md:px-0">
        <Button variant={VARIANT.PRIMARY} className="md:flex-1 w-full"
                onClick={handleSubmit}>
          Xác nhận
        </Button>
        <Button variant={!isMobile && VARIANT.SECONDARY}
                className={clsx(
                  isMobile ? 'w-full text-[#197D55] underline transition-all duration-300 !p-4' : 'md:flex-1 border-[#CCCBCB]'
                )}
                onClick={handleClose}>
          Huỷ bỏ
        </Button>
      </div>
    </form>
  )
}

export default ShippingConfirmationForm;
